import type { HeadingConfig } from '@ckeditor/ckeditor5-heading';
import type { FullscreenConfig } from '@ckeditor/ckeditor5-fullscreen';
import { Image } from '@ckeditor/ckeditor5-image';

export const headingsConfig = {
    options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' } as unknown as any,
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
    ]
} as HeadingConfig;


export const fullscreenConfig = {
    onEnterCallback: container =>
        container.classList.add(
            'editor-container',
            'editor-container_classic-editor',
            'editor-container_include-style',
            'editor-container_include-block-toolbar',
            'editor-container_include-word-count',
            'editor-container_include-fullscreen',
            'main-container'
        )
} as FullscreenConfig;


export const imageConfig = {
    toolbar: [
        'toggleImageCaption',
        'imageTextAlternative',
        '|',
        'imageStyle:inline',
        'imageStyle:wrapText',
        'imageStyle:breakText',
        '|',
        'resizeImage',
        '|',
        'ckboxImageEdit'
    ]
}


export const stylesConfig = {
    definitions: [
        { name: 'Article category', element: 'h3', classes: ['category'] },
        { name: 'Title', element: 'h2', classes: ['document-title'] },
        { name: 'Subtitle', element: 'h3', classes: ['document-subtitle'] },
        { name: 'Info box', element: 'p', classes: ['info-box'] },
        { name: 'CTA Link Primary', element: 'a', classes: ['button', 'button--green'] },
        { name: 'CTA Link Secondary', element: 'a', classes: ['button', 'button--black'] },
        { name: 'Marker', element: 'span', classes: ['marker'] },
        { name: 'Spoiler', element: 'span', classes: ['spoiler'] }
    ]
}

export const balloonToolbarConfig = ['bold', 'italic', '|', 'link', 'insertImage', '|', 'bulletedList', 'numberedList'];

export const blockToolbarConfig = ['fontSize', 'fontColor', 'fontBackgroundColor', '|', 'bold', 'italic', '|', 'link', 'insertImage', 'insertTable', '|', 'bulletedList', 'numberedList', 'outdent', 'indent'
];